export default __webpack_public_path__ + "static/media/projectsIcon.a2abf4a1.png";